import React from 'react';
import { Datagrid, EditButton, List, TextField, TextInput } from 'react-admin';
import { Breadcrumbs, Container, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';

const IndustryList: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Breadcrumbs sx={{ mt: 2 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/">
          Dashboard
        </MuiLink>
        <Typography color="text.primary">Industries</Typography>
      </Breadcrumbs>
      <List filters={[<TextInput key="search" label="Search" source="q" alwaysOn />]}>
        <Datagrid rowClick="edit" bulkActionButtons={false}>
          <TextField source="name" />
          <EditButton />
        </Datagrid>
      </List>
    </Container>
  );
};

export default IndustryList;
